import { AssessmentInfo, AssessmentStatus } from "@/types/assessment";

export type AssessmentPortalStatus =
  | "pending"
  | "scheduled"
  | "live_in_portal"
  | "review"
  | "concluded";

/**
 * Return the assessment status provided by API.
 */
export const calculateAssessmentStatus = (
  assessment: AssessmentInfo
): AssessmentStatus => {
  return assessment.status || "pending";
};

export const calculateAssessmentPortalStatus = (
  assessment: AssessmentInfo
): AssessmentPortalStatus => {
  const status = calculateAssessmentStatus(assessment);
  if (status === "pending") return "pending";
  if (status === "review") return "review";
  if (status === "completed") return "concluded";

  const scheduledFrom = assessment.scheduledFrom
    ? new Date(assessment.scheduledFrom)
    : null;
  const isScheduled = !!scheduledFrom && scheduledFrom > new Date();
  return isScheduled ? "scheduled" : "live_in_portal";
};
